<template>
  <div class="login">
    <div class="backgroundImg">
      <img class="loginPhoto" src="@/assets/photo.png" alt="">
    </div>
    <div class=loginContent>
      <p>学校端</p>
      <div class="remark">
        <p>
          <a href="https://www.lvluoxinli.com/static/html/guide.html" target="_blank"
            style="color:#999999">用户服务指南</a>&nbsp;&nbsp;&nbsp;
          <a href="https://www.lvluoxinli.com/static/html/clause.html" target="_blank"
            style="color:#999999">使用条款和隐私政策</a>&nbsp;&nbsp;&nbsp;
          服务邮箱：lvluoxinli@dingtalk.com
        </p>
        <p>
          ©2019 绿萝心理版权所有&nbsp;&nbsp;&nbsp;
          京ICP备18051758号-2 &nbsp;&nbsp;&nbsp;
          <i class="jgwablogo"></i>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202008381" target="_blank"
            style="color:#999999">京公网安备11010202008381</a>
        </p>
      </div>
      <div class="ContentFrom">
        <p>请绑定账号</p>

        <div class="block_2 flex-row">
          <div class="text-group_1 flex-col justify-between">
            <span class="text_3">该微信未绑定心理云平台账号</span>
            <span class="text_4">绑定后可通过微信扫码登录，无需输入账号密码</span>
          </div>
        </div>

        <p>填写以下信息绑定微信</p>
        <div class="form">
          <a-form status-icon class="demo-ruleForm" align="center">
            <!-- <div class="formItem" v-for="(item, index) in formData" :key="index"> -->
            <a-form-item prop="name">
              <a-input auto-complete="off" v-model="username" placeholder="请输入账号"></a-input>
            </a-form-item>
            <!-- </div> -->
            <a-form-item prop="pass">
              <a-input type="password" auto-complete="off" v-model="password" placeholder='请输入密码'
                @keyup.enter.native="userLogin"></a-input>
            </a-form-item>
          </a-form>
          <div class="loginIn">
            <a-button type="primary" :plain="true" @click="userLogin" :disabled="loginDisable">绑定微信</a-button>
          </div>
        </div>

        <div class="image-text_1 flex-row justify-between" @click="back_login">
          <img class="thumbnail_1" referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng40693c010928be0a54b70a06c8898d236210f6890f4557ceb6d4927a6d4d7ad0" />
          <span class="text-group_2">返回密码登录</span>
        </div>



      </div>


    </div>

  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
  import  url from '@/store/url_weixin'
  import {get} from '@/util/request'

// import WxLogin from 'vue-wxlogin';

export default {
  name: 'LoginView',
  data () {
    return {
      radio: '1',
      distance: 15,
      username: '',
      password: '',
      loginDisable: false,
      errorNumber:4,
    }
  },
  computed: {
    ...mapState([
      'isLogin',
      'teacherAdmin',
      'userInfo',
      'loginFlag'
    ])
  },
  methods: {
    ...mapMutations([
      'setGradesMaxMin'
    ]),
    ...mapActions([
      'getLogin',
      'getUserInfo',
      'getLogin_auth',
      'getUpdateTeacherInfo'
    ]),
    onChange (e) {
      this.radio = e.target.value
    },
    back_login () {
       sessionStorage.setItem('wxuserInfo', JSON.stringify({}))
       this.$router.push('/')
    },
    async userLogin () {
      this.loginDisable = true
      if (this.username === '' || this.password === ''){
        this.loginDisable = false
        this.$message.error('账号或密码信息输入有误，请检查')
        return
      }
      if (this.password.length < 6) {
        this.loginDisable = false
        this.$message.error('账号或密码信息输入有误，请检查')
        return
      }
      try {
        // 微信登录验证用户明密码
        const res = await this.getLogin_auth({username: this.username, password: this.password})
        // 登录
        if (this.isLogin === '联系平台客服解锁账号，或者等待1小时后解锁账号') {
          this.$message.error('联系平台客服解锁账号，或者等待30分钟后解锁账号')
          this.loginDisable = false
          return
        }
        let { success, data } = res.data

        if (success && !res.data.data.TOKEN) {
          this.loginDisable = false
          this.$message.error('登录失败')
          return
        }
        if (!success) {
          this.$message.error(`您还有${data.data.available_num}次尝试登录的机会。请确保您输入的账号和密码无误再尝试登录！`)
          this.loginDisable = false
          return
        }
      
        sessionStorage.setItem('teacherAdmin', JSON.stringify(this.teacherAdmin))
        let openids = JSON.parse(sessionStorage.getItem('wxuserInfo'))
        
        

        await this.getUserInfo()
        if (this.userInfo.LANG) {
            this.$message.error('该账号已被其他微信绑定，请联系校领导或客服')
        } else {
          let wxdata = await get(url.wxUserInfo, { openid: openids.openid, access_token: openids.access_token, lang: "zh_CN" })
          let result = {
            uid: data.UID,
            IMG: wxdata.headimgurl,
            NICKNAME: wxdata.nickname,
            LANG: openids.unionid,
            school_id: 1,
          }
           await this.getUpdateTeacherInfo(result) //绑定，直接更新，判断是否被绑定
            this.$router.push('/login/weixinsuccess')
        }
       
       
    

      } catch (e) {
        console.log(e)
        this.loginDisable = false
        this.$message.error('当前您的网络情况不佳，请刷新或稍后再试~')
      }
    }
  }
}
</script>

<style scoped>
p{
  display: block;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.login{
  display: flex;
  height: 100%;
  position: relative;
  background: #F8F9FB;
}
.login > p {
  position: absolute;
  bottom: 20px;
  left: 50%;
  color: #999;
  transform: translateX(-50%);position: absolute;
  bottom: 20px;
  left: 50%;
  color: #999;
  transform: translateX(-50%);
}
.login .backgroundImg{
  width:500px;
  height: auto;
  background: url('../../assets/background.png');
  background-size: cover;
  position: relative;
}

.login .backgroundImg .loginPhoto{
  width: 400px;
  height: auto;
  right: 0px;
  bottom: 40px;
  position: absolute;
}

.loginContent{
  flex: 1;
  height: auto;
  background:#FFFFFF;
  position: relative;
}
.loginContent .remark{
  position: absolute;
  width: 100%;
  bottom: 10px;
  font-size:14px;
  color:rgba(153,153,153,1);
  line-height:14px;
  text-align: center;
}
.loginContent .remark>p{
  padding-bottom: 10px;
}
.loginContent .ContentFrom{
  position: absolute;
  left: 50%;
  top: 50%;
  /* transform:translateY(-50%); */
  transform: translate(-50%, -50%);
}
.loginContent>p:first-child{
  font-size:18px;
  font-weight:500;
  color:rgba(153,153,153,1);
  line-height:18px;
  letter-spacing:1px;
  top: 50px;
  right: 60px;
  position: absolute;
}
.loginContent .ContentFrom>p:first-child{
  height:40px;
  font-size:40px;
  font-weight:600;
  color:rgba(0,0,0,1);
  line-height:40px;
}.loginContent .ContentFrom>p:nth-child(2){
  font-size:24px;
  font-weight:600;
  color:rgba(0,0,0,1);
  line-height:30px;
  margin-top: 16px;
}.loginContent .ContentFrom>p:nth-child(3){
  width:222px;
  height:30px;
  font-size:18px;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height:30px;
  margin-top: 50px;
}
.loginContent .ContentFrom .form{
  width: 360px;
}
.loginContent .loginIn{
  text-align: left;
}
.loginContent .loginIn button {
  width:210px;
  height:45px;
}
.loginContent .ant-form {
  width: 75%;
  /* margin: 0 auto; */
}
.login .ant-btn{
  width:210px;
  height:45px;
  background-color: #3c4e6a;
  border-radius:4px;
}
.login .ant-btn-primary{
  background:rgba(36,192,148,1);
  border-color: rgba(36,192,148,1);
  margin-top: 30px;
}
.login .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
.login .ant-input {
  border: none;
  border-radius:4px;
  /* border-bottom-color: rgba(192,196,204,1); */
  /* border-bottom-style: solid; */
  border-bottom-width: 1px;
  padding: 1px 15px;
  background: #F5F6F8;
  color: #999999;
  width:360px;
  height:45px;
}
.login .ant-input:hover{
  outline: none;
  border-bottom-color:#3c4f6a;
}
.login .ant-input:focus {
    border: none;
    /* border-bottom: 1px solid #3c4f6a !important; */
    box-shadow: none;
}
.login .ant-row.ant-form-item{
  top: 20px;
  margin-bottom: 20px;
}
.login a {
  text-decoration: underline;
}
.jgwablogo{
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url('../../assets/jgwab.png');
  position: relative;
  top: 3px;
}
.login .ant-btn-primary[disabled] {
  color: #FFFFFF;
}
@media (max-width: 1200px){
    .login .backgroundImg {
      width:420px;
    }
  }
@media (max-width: 900px){
  /* .login .backgroundImg {
    display: none;
  } */
  .login {
    width: 900px;
  }
}
@media (max-height: 600px){
  .login {
    height: 600px;
  }
}

.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}

.image-text_1 {
  width: 120px;
  height: 16px;
  margin-top: 60px;
   cursor: pointer
}

.thumbnail_1 {
  width: 16px;
  height: 16px;
}

.text-group_2 {
  width: 96px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 0.6);
  font-size: 16px;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 16px;
}

.text-wrapper_1 {
  width: 200px;
  height: 40px;
  margin: 138px 0 0 815px;
}

.block_2 {
  width: 378px;
  height: 44px;
  margin: 24px 0 0 5px;
}
.text_3 {
  width: 234px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 146, 0, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 27px;
}

.text_4 {
  width: 378px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 146, 0, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 8px;
}
</style>
